import { h, Component } from "preact";
import { connect } from "react-redux";
import Page from "../../components/Page";
import Content from "../../components/Content";
import { getEvent } from "../../state/actions/eventActions";
import { getOrder } from "../../state/actions/orderActions";
import PaymentSuccess from "../../components/PaymentSuccess";

/**
 * Used for additional questions after check out
 *
 * @class AfterCheckout
 * @extends {Component}
 */
class AfterCheckout extends Component {
  componentDidMount() {
    const { event, order, getEvent, getOrder, eventSlug, orderId } = this.props;
    if (!event.data && !event.loading) {
      getEvent(eventSlug);
    }
    if (!order.data && !order.orderRequest.loading) {
      getOrder(orderId);
    }
  }
  render({ event, order }) {
    if (!event.data || !order.data) {
      return;
    }
    const background = event.widget ? false : true;
    return (
      <div style={{ backgroundColor: "#F7FBFF" }}>
        <Page transparent={true} background={background} border={false}>
          <Content>
            <PaymentSuccess event={event.data} order={order.data} />
          </Content>
        </Page>
      </div>
    );
  }
}

export default connect(
  (state, ownProps) => ({ event: state.event, order: state.order }),
  { getEvent, getOrder }
)(AfterCheckout);



// WEBPACK FOOTER //
// ./routes/afterCheckout/AfterCheckout.js